"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidAction = exports.invalidActionProperties = void 0;
var isNumericProperty_1 = require("./isNumericProperty");
var isNumericValue_1 = require("./isNumericValue");
exports.invalidActionProperties = ['typeID', 'name', 'label', 'shortLabel', 'hydrogenInterruptible', 'notes', 'upgradableTypes'];
var isValidAction = function (action, assetTypeDefinitions) {
    // Check valid property chosen
    if (action.property === '' ||
        exports.invalidActionProperties.includes(action.property) ||
        !assetTypeDefinitions.find(function (assetTypeDefinition) { return assetTypeDefinition.columnName === action.property; })) {
        return false;
    }
    var isNumeric = (0, isNumericProperty_1.isNumericProperty)(action.property, assetTypeDefinitions);
    // Check adjustment type is valid for property
    if (action.adjustmentType === 'multiply' && !isNumeric) {
        return false;
    }
    // Check value is valid for property
    if (isNumeric && !(0, isNumericValue_1.isNumericValue)(action.value)) {
        return false;
    }
    // The action has passed the validation
    return true;
};
exports.isValidAction = isValidAction;
//# sourceMappingURL=isValidAction.js.map